var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ContentState, convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { CHIP_ENTITY_TYPE } from '../../constants/chipConstants';
export var editorStateFromRichTextEditorValue = function (value, decorator) {
    return value && value.formattedValue ? EditorState.moveSelectionToEnd(EditorState.createWithContent(convertFromRaw(JSON.parse(value.formattedValue)), decorator))
        : value && value.plainTextValue ? EditorState.moveSelectionToEnd(EditorState.createWithContent(ContentState.createFromText(value.plainTextValue), decorator))
            : EditorState.createEmpty(decorator);
};
export var richTextEditorValueFromEditorState = function (editorState, chipReferences) {
    if (chipReferences === void 0) { chipReferences = []; }
    var rawContent = convertToRaw(editorState.getCurrentContent());
    var plainTextContent = getPlainText(rawContent, chipReferences);
    var hasAnyContent = plainTextContent && plainTextContent !== '';
    return hasAnyContent
        ?
            {
                formattedValue: JSON.stringify(rawContent),
                plainTextValue: plainTextContent,
            }
        : undefined;
};
var getPlainText = function (rawContent, chipReferences) {
    return rawContent.blocks
        .map(function (block) { return getBlockTextWithChipNames(rawContent, chipReferences, block); })
        .join('\n');
};
var getBlockTextWithChipNames = function (rawContent, chipReferences, block) {
    if (!block) {
        return '';
    }
    var blockText = block.text;
    var addedCharacters = 0;
    block.entityRanges.forEach(function (entityRange) {
        var entity = rawContent.entityMap[entityRange.key];
        if (entity && entity.type === CHIP_ENTITY_TYPE) {
            var chipData_1 = entity.data;
            var chipReference = chipReferences.find(function (reference) { return reference.id === chipData_1.id && reference.objectType === chipData_1.objectType; });
            var chipName = (chipReference === null || chipReference === void 0 ? void 0 : chipReference.name) || 'Removed';
            var insertNameAt = entityRange.offset + addedCharacters;
            blockText = blockText.substring(0, insertNameAt) + chipName + blockText.substring(insertNameAt);
            addedCharacters += chipName.length;
        }
    });
    return blockText;
};
export var filterOutReferencesWithoutChips = function (editorState, chipReferences) {
    var rawContent = convertToRaw(editorState.getCurrentContent());
    if (!rawContent.entityMap) {
        return __spreadArray([], chipReferences, true);
    }
    var chips = Object.values(rawContent.entityMap)
        .filter(function (entity) { return entity.type === CHIP_ENTITY_TYPE; })
        .map(function (chipEntity) { return chipEntity.data; });
    return chipReferences.filter(function (reference) { return !!chips.find(function (chip) { return reference.id === chip.id && reference.objectType === chip.objectType; }); });
};
//# sourceMappingURL=richTextValueUtils.js.map